import React from "react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { FormattedMessage } from "react-intl";
import { useTheme } from "@mui/material/styles";
import formatIntegerDotThousands from "bundles/common/utils/formatIntegerDotThousands";

const CVThequeResultsCount = ({ count }) => {
  const hasCount = count != null;
  const theme = useTheme();

  const useStyles = makeStyles(() => ({
    resultsCount: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexWrap: "wrap",
      gap: "12px",
    },
    countTitle: {
      color: "#111",
      fontSize: "24px",
      fontWeight: 600,
      lineHeight: 1.2,
    },
    countNumber: {
      padding: "6px 16px",
      backgroundColor: theme.palette.secondary.hover || "#D1F812",
      borderRadius: "999px",
      fontSize: "22px",
      fontWeight: 700,
      fontVariantNumeric: "tabular-nums",
      letterSpacing: "0.01em",
      color: "#111",
      lineHeight: 1.2,
      boxShadow: "0 1px 2px rgba(0,0,0,0.06)",
    },
  }));

  const classes = useStyles();

  if (!hasCount) {
    return null;
  }

  const formatted = formatIntegerDotThousands(count);

  return (
    <Box className={classes.resultsCount}>
      <Typography variant="h3" component="span" className={classes.countTitle}>
        <FormattedMessage id="candidate.candidate" defaultMessage="Candidates" />
      </Typography>
      <Box component="span" className={classes.countNumber} aria-label={formatted}>
        {formatted}
      </Box>
    </Box>
  );
};

export default CVThequeResultsCount;
